import ConditionLabel from './ConditionLabelContainer'

export default ConditionLabel
